<!-- page content start -->
<ion-header class="header -primary" mode="md">
  <ion-toolbar color="primary" mode="md">
    <ion-title class="title-padding title-padding-on-large" ngslot="start"><img src="../../assets/logo_table42.svg"></ion-title>


  </ion-toolbar>
</ion-header>

<ion-content color="primary">

<ng-container>

    <div class="ion-text-center ion-padding" color="primary">
      <h2 class="reservation-success__heading">Hvala za vaše mnenje.</h2>
      <h3>
        <ion-icon class="checkmark"></ion-icon>
      </h3>
      <p class="reservation-success__subheading">Skupaj bomo lahko izkušnjo še izboljšali.</p>
    </div>

</ng-container>

</ion-content>